"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _index = require("../../../../utils/styles/index");
/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */

/* ++++++++++ --------------- EXPORT : DROPDOWN : MULTI SELECT : STYLES --------------- ++++++++++ */


var _default = {
  multiselectdropdown: {
    position: 'relative',
    minWidth: (0, _index.pxToEm)(210),
    maxWidth: (0, _index.pxToEm)(275),
    height: (0, _index.pxToEm)(56),
    zIndex: 1,
    '& .name-menuItems': {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
      padding: (0, _index.replacePXinStringWithEM)('10px'),
      backgroundColor: _index.theme.color.light.light.swatch,
      boxShadow: _index.theme.boxShadow.small,
      '& .searchbar': {
        marginBottom: (0, _index.pxToEm)(15)
      },
      '& .all-items': {
        fontSize: (0, _index.pxToEm)(14),
        color: _index.theme.color.neutral.dark.swatch,
        marginBottom: (0, _index.pxToEm)(15),
        '&:hover': {
          cursor: 'pointer'
        }
      },
      '& .items': {
        height: (0, _index.pxToEm)(220),
        overflow: 'scroll',
        overflowX: 'hidden',
        extend: (0, _index.coloredScrollBar)(_index.theme.color.primary.medium.swatch)
      },
      '& .button': {
        margin: (0, _index.replacePXinStringWithEM)("8px 0 0")
      },
      '&.active-true': {
        height: 'auto',
        maxHeight: (0, _index.pxToEm)(600),
        overflow: 'hidden',
        transition: 'all .15s'
      },
      '&.active-false': {
        height: (0, _index.pxToEm)(0),
        padding: 0,
        overflow: 'hidden',
        transition: 'all .15s',
        pointerEvents: 'none',
        opacity: 0
      }
    },
    '& .name-managecontrolitem': {
      display: 'block',
      marginTop: '15px'
    },
    '& .name-addcontrolitem': {
      display: 'block',
      marginTop: '5px'
    },
    '& .button.name-filter': {
      width: '100%'
    },
    '&.disabled-true': {
      extend: _index.disable
    }
  }
};
exports.default = _default;